export const levelSkills = {
    languajes : [
        {
            level: 1,
            textEs: "Básico"
        },
        {
            level: 2,
            textEs: "Intermedio"
        },
        {
            level: 3,
            textEs: "Avanzado"
        },
        {
            level: 4,
            textEs: "Fluido"
        }
    ],
    skills: [
        {
            level: 1,
            textEs: "Básico"
        },
        {
            level: 2,
            textEs: "Intermedio"
        },
        {
            level: 3,
            textEs: "Avanzado"
        },
        {
            level: 4,
            textEs: "Experto"
        }
    ],
};